// 引入rsa加密库
import JSEncrypt from 'jsencrypt'
//引用AES源码js
import CryptoJS from 'crypto-js'

// // 1. 创建 JSEncrypt 实例
// const keySize = 512; // 密钥长度，可以根据需要调整
// const encrypt = new JSEncrypt({ default_key_size: keySize });

// const privateKeySelf = 'MC4CAQACBQDfAwa9AgMBAAECBA8kYvkCAwD7jwIDAOLzAgMA30kCAwCWEQIDAIu3'
// const publicKeySelf = 'MCAwDQYJKoZIhvcNAQEBBQADDwAwDAIFAN8DBr0CAwEAAQ=='
// // 2. 异步生成密钥对
// encrypt.getKey(() => {
//   // 3. 获取生成的密钥对
//   const privateKey = encrypt.getPrivateKey();
//   const publicKey = encrypt.getPublicKey();

//   // 4. 打印私钥和公钥
//   console.log('Private Key:\n', privateKey);
//   console.log('\nPublic Key:\n', publicKey);
// });



// const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDNMw7N9cWlytR8dznwaKE+s/8qPdXbkvIomQyJb031XcxLXl7SkGv1UUWtWE+pcS6njqCC+meKP0V3BhOv6RHIi5uXj7GE4OlauAbyVdGmPv9SJmx7NQ6Qdab21ZD7Hxe6XxcM6XQFht7sMsPCZxiYbrhdf0JQ0KbnVJltSOBYXQIDAQAB'



// 加密
function RSAEncrypt(object) {
  const encrypt = new JSEncrypt(); // 创建加密对象实例
  // 公钥
  // const publicKey = publicKeySelf
  const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDNMw7N9cWlytR8dznwaKE+s/8qPdXbkvIomQyJb031XcxLXl7SkGv1UUWtWE+pcS6njqCC+meKP0V3BhOv6RHIi5uXj7GE4OlauAbyVdGmPv9SJmx7NQ6Qdab21ZD7Hxe6XxcM6XQFht7sMsPCZxiYbrhdf0JQ0KbnVJltSOBYXQIDAQAB'
  encrypt.setPublicKey(publicKey); // 设置公钥
  const pasd = encrypt.encrypt(object);
  return pasd
}

// 解密
function RSADecrypt(object) {
  const decrypt = new JSEncrypt(); 
  // 私钥
  // const prikey = privateKeySelf
  var prikey = 'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAM0zDs31xaXK1Hx3OfBooT6z/yo91duS8iiZDIlvTfVdzEteXtKQa/VRRa1YT6lxLqeOoIL6Z4o/RXcGE6/pEciLm5ePsYTg6Vq4BvJV0aY+/1ImbHs1DpB1pvbVkPsfF7pfFwzpdAWG3uwyw8JnGJhuuF1/QlDQpudUmW1I4FhdAgMBAAECgYBCjBpzBQ/SUtNSgkASDXytnyZThrZCfYd3TxtXvvcjagYFM1fBJgE9D9xu+ULsir48rO61S4wks5xNm3TrCcUwFekSVgm23ODGlGylYYY40yzDPxYY3+eIfjwdBIlZkOCJsYXAbyOVSLuBt8D+4/InwAB0BtPoTVVqKnkqNgiXAQJBAPGEp/JRztnK5X2RT4konfQbwQbJuOFnm7vtss0NmKSBwUB3J0ZSOHnifB6SSpF/dWkPDltfAQlphFzv6b9OuGECQQDZgOcxsV0necOTywMC3dtM6txnxJTST28H9ZhWxp4S4QFbh52All2JR2AFIO9U2dIs8vNeFtNdXpaLaWEM/fF9AkA7qATD+ikZ6uAc0BPRUVMSxPg88P7Vzn3NQb10oPMfT12oysXMvOpuUN9PvdrlbZJWzP1C3IipBoNHYYtfUdaBAkAwBCkF62XpRRRMGFE93MSBIogt0FQaabbVRv6uiYJ0IIAwOKwoqwlTORKVj0PGs5+WlLvtVZSr1Cnf9Q+b0qPxAkBWDFOHEkk8qL89PK4DQsxc6N/msafegPTVIY6iU1vEOViyqqTpI5pbv4iclMJmmIP7TLgynoO/h4oKPwfv26n2'
  decrypt.setPrivateKey(prikey)//设置秘钥
  const uncrypted = decrypt.decrypt(object);
  return uncrypted
}

//验签
function verify(data,signData ) {
  // 公钥
  // const publicKey = publicKeySelf
  let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDNMw7N9cWlytR8dznwaKE+s/8qPdXbkvIomQyJb031XcxLXl7SkGv1UUWtWE+pcS6njqCC+meKP0V3BhOv6RHIi5uXj7GE4OlauAbyVdGmPv9SJmx7NQ6Qdab21ZD7Hxe6XxcM6XQFht7sMsPCZxiYbrhdf0JQ0KbnVJltSOBYXQIDAQAB';
  const verifyEncrypt = new JSEncrypt();
  // 设置公钥（同样可以从服务端获取）
  verifyEncrypt.setPublicKey(publicKey);
  // 6. 验证签名
  const isSignatureValid = verifyEncrypt.verify(data,signData,CryptoJS.SHA256);
  console.log('验证签名--',isSignatureValid);
  return isSignatureValid
}

// 加签
function REAsign (form) {
  const data = JSON.stringify(form)
  // 私钥
  // const prikey = privateKeySelf
  let prikey = 'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAM0zDs31xaXK1Hx3OfBooT6z/yo91duS8iiZDIlvTfVdzEteXtKQa/VRRa1YT6lxLqeOoIL6Z4o/RXcGE6/pEciLm5ePsYTg6Vq4BvJV0aY+/1ImbHs1DpB1pvbVkPsfF7pfFwzpdAWG3uwyw8JnGJhuuF1/QlDQpudUmW1I4FhdAgMBAAECgYBCjBpzBQ/SUtNSgkASDXytnyZThrZCfYd3TxtXvvcjagYFM1fBJgE9D9xu+ULsir48rO61S4wks5xNm3TrCcUwFekSVgm23ODGlGylYYY40yzDPxYY3+eIfjwdBIlZkOCJsYXAbyOVSLuBt8D+4/InwAB0BtPoTVVqKnkqNgiXAQJBAPGEp/JRztnK5X2RT4konfQbwQbJuOFnm7vtss0NmKSBwUB3J0ZSOHnifB6SSpF/dWkPDltfAQlphFzv6b9OuGECQQDZgOcxsV0necOTywMC3dtM6txnxJTST28H9ZhWxp4S4QFbh52All2JR2AFIO9U2dIs8vNeFtNdXpaLaWEM/fF9AkA7qATD+ikZ6uAc0BPRUVMSxPg88P7Vzn3NQb10oPMfT12oysXMvOpuUN9PvdrlbZJWzP1C3IipBoNHYYtfUdaBAkAwBCkF62XpRRRMGFE93MSBIogt0FQaabbVRv6uiYJ0IIAwOKwoqwlTORKVj0PGs5+WlLvtVZSr1Cnf9Q+b0qPxAkBWDFOHEkk8qL89PK4DQsxc6N/msafegPTVIY6iU1vEOViyqqTpI5pbv4iclMJmmIP7TLgynoO/h4oKPwfv26n2';
  const verifyEncrypt = new JSEncrypt();
  // 设置私钥钥（同样可以从服务端获取）
  verifyEncrypt.setPrivateKey(prikey);
  // 获取签名
  const signatured = verifyEncrypt.sign(data,CryptoJS.SHA256,'sha256');
  return signatured
}

export {RSADecrypt,RSAEncrypt,verify,REAsign}
